import(/* webpackMode: "eager", webpackExports: ["ProfileCard"] */ "/vercel/path0/components/cards/profile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LatestPosts"] */ "/vercel/path0/components/home-page/latest-posts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypedBios"] */ "/vercel/path0/components/home-page/typed-bios.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/image-component.js");
